import { Routes } from '@angular/router';
import { AppComponent } from './app.component';
const ɵ0 = () => import("./worldarchery_indoor-world-series-calendar/indoor-world-series-calendar.module.ngfactory").then(m => m.IndoorWorldSeriesCalendarModuleNgFactory), ɵ1 = () => import("./worldarchery_indoor-world-series-amateur-ranking/indoor-world-series-amateur-ranking.module.ngfactory").then(m => m.IndoorWorldSeriesAmateurRankingModuleNgFactory), ɵ2 = () => import("./worldarchery_indoor-world-series-elite-ranking/indoor-world-series-elite-ranking.module.ngfactory").then(m => m.IndoorWorldSeriesEliteRankingModuleNgFactory), ɵ3 = () => import("./worldarchery_indoor-world-series-teams/indoor-world-series-teams.module.ngfactory").then(m => m.IndoorWorldSeriesTeamsModuleNgFactory);
const routes = [
    { path: '', component: AppComponent,
        children: [
            { path: '', redirectTo: 'calendar', pathMatch: 'full' },
            {
                path: 'calendar',
                loadChildren: ɵ0
            },
            {
                path: 'open-ranking',
                loadChildren: ɵ1
            },
            {
                path: 'elite-ranking',
                loadChildren: ɵ2
            },
            {
                path: 'team-ranking',
                loadChildren: ɵ3,
            }
        ]
    },
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3 };
